function popupVideo() {
  const $btn = $('.js-popup-video');
  $btn.magnificPopup({
    disableOn: 767,
    type: 'iframe',
    mainClass: 'mfp-fade popup-video',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function() {
        const closeVideo = $btn.data('close-video');

        if (closeVideo !== undefined) {
          var iframe = document.querySelector('iframe');
          var player = new Vimeo.Player(iframe);

          player.on('ended', function(){
            $.magnificPopup.close()
          });
        };
      }
    }
  });
}

popupVideo();

module.exports = {
  popupVideo
};



// WEBPACK FOOTER //
// ../assets/js/popups.js